import { render } from "./Banner.vue?vue&type=template&id=558a5018&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=558a5018&scoped=true&lang=css"

import exportComponent from "/Users/rithy/Documents/code/vpos.club/vpos-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558a5018"]])

export default __exports__